import { hasElement } from '../../dev';

/* STATIC IMPORTS */

// static imports which should be loaded
// every time the app is loaded
// static imports has moved to ./client/src/styles/app.scss to minimize cls
import './components/m/anchor-navigation';

/* DYNAMIC IMPORTS */

// ATOMS
if (hasElement('[class*="background"]')) {
  import('./components/a/background');
}
if (hasElement('ul') || hasElement('ol')) {
  import('./components/a/list');
}
if (hasElement('.markerBlock')) {
  import('./components/a/marker');
}
if (hasElement('.chip')) {
  import('./components/a/chip');
}
if (hasElement('.activity-indicator')) {
  import('./components/a/activity-indicator');
}
if (hasElement('.page-indicator')) {
  import('./components/a/page-indicator/style.scss');
}
if (hasElement('.tooltip')) {
  import('./components/a/tooltip');
}
if (hasElement('.tooltip_container')) {
  import('./components/m/tooltip');
}
if (hasElement('button') || hasElement('.button')) {
  import('./components/a/button');
}
if (hasElement('.dialog-overlay')) {
  import('./components/a/dialog-overlay');
}
if (hasElement('.badge')) {
  import('./components/a/badge');
}
if (hasElement('.stickerBlock')) {
  import('./components/a/sticker');
}
if (hasElement('.notification')) {
  import('./components/a/notification');
}
if (hasElement('iframe')) {
  import('./components/a/iframe');
}

if (hasElement('.dropdown')) {
  import('./components/a/dropdown');
}

if (hasElement('.range')) {
  import('./components/a/range');
}
if (hasElement('.complex-table')) {
  import('./components/a/table');
}

// MOLECULES
if (hasElement('.simple-text-media-element')) {
  import('./components/m/simple-text-media-element');
}
if (hasElement('.simple-text-tiles-element')) {
  import('./components/m/simple-text-tiles-element');
}

if (hasElement('.special-hotspot-element')) {
  import('./components/m/special-hotspot-element');
}
if (hasElement('.modal')) {
  import('./components/m/modal');
}
if (hasElement('.special-product-promotion-element')) {
  import('./components/m/special-product-promotion-element');
}
if (hasElement('.special-icon-tiles-element')) {
  import('./components/m/special-icon-tiles-element');
}
if (hasElement('.prominent-image-text-marker-element')) {
  import('./components/m/prominent-image-marker-element');
}
if (hasElement('.prominent-text-media-element')) {
  import('./components/m/prominent-text-media-element');
}
if (hasElement('.sticky-service-links')) {
  import('./components/m/sticky-service-links');
}
if (hasElement('.prominent-image-text-marker-overlay-element')) {
  import('./components/m/prominent-img-markeroverlay-element');
}
if (hasElement('.customer-logos-element')) {
  import('./components/m/customer-logos-element');
}
if (hasElement('.downloads-element')) {
  import('./components/m/downloads-element');
}
if (hasElement('.element-faq')) {
  import('./components/m/faq');
}
if (hasElement('.special-key-facts-element')) {
  import('./components/m/special-key-facts-element');
}
if (hasElement('.prominent-gallery-stripe-element')) {
  import('./components/m/prominent-gallery-stripe');
}
if (hasElement('.social-connect')) {
  import('./components/m/social-connect/style.scss');
}
if (hasElement('.event-summary')) {
  import('./components/m/event-summary/style.scss');
}
if (hasElement('.event-details')) {
  import('./components/m/event-detail/style.scss');
}
if (hasElement('.tabs-icon-text-element')) {
  import('./components/m/tabs-icon-text-element');
}

if (hasElement('.special-timeline-element')) {
  import('./components/m/special-timeline');
}

if (hasElement('.tabs-text-element')) {
  import('./components/m/tabs-text-element');
}
if (hasElement('.prominent-image-grid')) {
  import('./components/m/prominent-image-grid');
}

if (hasElement('.quotes')) {
  import('./components/m/quotes');
}

if (hasElement('.header__search-autocomplete')) {
  import('./components/m/search/autocomplete');
}
if (hasElement('.search-results')) {
  import('./components/m/search/results');
}


if (hasElement('.blog')) {
  import('./components/o/blog');
}
if (hasElement('.blog-entry')) {
  import('./components/m/blog-entry/style.scss');
}
if (hasElement('.post-summary')) {
  import('./components/m/post-summary/style.scss');
}
if (hasElement('.press-summary')) {
  import('./components/m/press-summary/style.scss');
}
if (hasElement('.press-entry')) {
  import('./components/m/press-entry/style.scss');
}
if (hasElement('.press-contact')) {
  import('./components/m/press-contact/style.scss');
}
if (hasElement('.event-ticket-form-element')) {
  import('./components/m/event-ticket-form-element');
}
if (hasElement('.newsletter-subscription-element')) {
  import('./components/m/newsletter-subscription-element');
}
if (hasElement('.glossary-element') || hasElement('.GlossaryEntry')) {
  import('./components/m/glossar-element');
}

if (hasElement('.table-of-contents-element')) {
  import('./components/m/table-of-contents');
}

if (hasElement('.user-report-overview-element')) {
  import('./components/m/user-reports-element');
}

if (hasElement('.references-page-detail')) {
  import('./components/m/references-element');
  import('./components/m/prominent-text-media-element');
}
if (hasElement('.content-element')) {
  import('./components/m/content-element');
}

if (hasElement('.subforms-element')) {
  import('./components/m/subform-element');
}

if (hasElement('.element--virtual')) {
  import('./components/m/element-virtual');
}

// ORGANISMS
if (hasElement('.header')) {
  import('./components/o/header');
}

if (hasElement('.child-pages-overview-element')) {
  import('./components/m/child-pages-overview-element');
}
if (hasElement('.case-studies-element')) {
  import('./components/o/case-studies');
}
if (hasElement('.blog')) {
  import('./components/o/blog');
}
if (hasElement('.press')) {
  import('./components/o/press');
}

// TEMPLATES
